<template>
    <div>
        <div class="title marginT15">
            배송 정보
            <div class="clear"></div>
        </div>
        <div class="table_wrap">
            <el-table
                :data="deliveryList"
                style="width: 100%"
                empty-text="데이터가 없습니다."
            >
                <el-table-column
                    class="table_no"
                    type="index"
                    label="#"
                    width="70"
                    class-name="num"
                    :index="tableIndex"
                >
                </el-table-column>
                
                <el-table-column
                    label="배송지명" width="150" class-name="text-center" prop="md_title"
                >
                    <template slot-scope="scope">
                        <div>
                           {{ replaceHyphen(scope.row.md_title) }}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    label="수령인명" width="150" class-name="text-center" prop="md_receiver"
                >
                    <template slot-scope="scope">
                        <div>
                           {{ replaceHyphen(scope.row.md_receiver) }}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    label="수령인 전화번호" width="200" class-name="text-center" prop="md_hp"
                >
                    <template slot-scope="scope">
                        <div>
                           {{ phoneFormatter(scope.row.md_hp) }}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    label="배송지주소" width="" class-name="text-center" prop="md_addr1"
                >
                    <template slot-scope="scope">
                        <div>
                           {{ returnAddress(scope.row) }}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    label="배송 메모" width="" class-name="text-center" prop="md_memo"
                >
                    <template slot-scope="scope">
                        <div>
                           {{ replaceHyphen(scope.row.md_memo) }}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    label="등록일" width="100" class-name="text-center" prop="created_at"
                >
                    <template slot-scope="scope">
                        <div>
                           {{ returnDateFormat(scope.row.created_at) }}
                        </div>
                    </template>
                </el-table-column>
               
                <el-table-column
                    label="옵션" width="250" class-name="text-center"
                >
                    <template slot-scope="scope">
                        <el-button
                            size="mini"
                            type="warning"
                            @click="showModal(scope.row)">
                            수정
                        </el-button>
                        <el-button
                            size="mini"
                            type="danger" 
                            @click="runDeleteConfirm(scope.row)">
                            삭제
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <member-delivery-modal></member-delivery-modal>
        </div>  
    </div>    
</template>

<script>
import util from "@/mixins/util";
import contentMixins from "@/mixins/contentMixins"
import dateMixins from "@/mixins/dateMixins";
import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/mixins/event-bus";
import MemberDeliveryModal from "@/components/modal/MemberDeliveryModal"
import numberHyphen from "@/mixins/numberHyphen"
export default {
    name: "DeliveryListMemberComponent",
    mixins: [contentMixins, dateMixins, alertMixins, numberHyphen],
    components: {MemberDeliveryModal},
    inject: [],
    provide() {
        return {
        }
    },
    props: {
        memberKey: {default: 0},
    },
    data() {
        return {
            deliveryList: []
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.getMemberDelivery()
    },
    mounted() {
        EventBus.$on('getMemberDelivery', this.getMemberDelivery)
    },
    beforeDestroy() {
        EventBus.$off('getMemberDelivery')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        getMemberDelivery(){
            let params = {
                ip: 0,
                no: this.memberKey
            };
            EventBus.$emit('apiLoading', true);
            try {
                this.$api.$member.getMemberDeliveryInfo(params).then(res => res.Data.Result).then(res => {
                    if (!util.isEmpty(res.List)) {
                        this.deliveryList = res.List.List;
                    }
                })
            } catch (e) {
                console.log(e);
            }
            EventBus.$emit('apiLoading', false)
        },
        tableIndex(index) {
            return this.deliveryList.length - index 
        },
        returnAddress(data){
            if(!util.isEmpty(data)){
                return `${data.md_zipcode} ${data.md_addr1} ${data.md_addr2}`
            }
        },
        showModal(data){
            this.$modal.show('member-delivery-modal',{ deliveryData: data})
        },
        runDeleteConfirm(data){
            if(data.md_is_default == 1){
                return this.errorAlert('기본 배송지는 삭제할 수 없습니다.');
            }
            this.createConfirm({
                content: '배송정보 삭제하시겠습니까?</br> 삭제 후에는 복구가 불가능합니다.',
                confirm: () => {
                    this.runDeleteMemberDelivery(data);
                } 
            })
        },
        runDeleteMemberDelivery(data){ 
            let params = {
                md_idx: data.md_idx,      
                mb_no: this.memberKey          
            }
            EventBus.$emit('apiLoading', true);
            try {
                this.$api.$member.deleteMemberDelivery(params).then(res => res.Data.Result).then(res => {
                    let type = this.returnResultType(res.Info.Type)
                    if(type == true) {
                        EventBus.$emit('apiLoading', false);
                        this.getMemberDelivery();
                        EventBus.$emit('writeGetMember')
                    }else {
                        EventBus.$emit('apiLoading', false);
                        this.errorAlert(type);
                    }
                })
            }catch (e) {
                console.log(e)
            }
            EventBus.$emit('apiLoading', false)
        },
        returnResultType(type) {
            switch (type) {
                case 1 :
                    return true;
                case -901:
                    return '기본 배송지는 삭제할 수 없습니다.';
                default :
                    return "배송지 삭제에 실패하였습니다."
            }
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
